import { render, staticRenderFns } from "./leaving-message.vue?vue&type=template&id=32f269a9&scoped=true&"
import script from "./leaving-message.vue?vue&type=script&lang=js&"
export * from "./leaving-message.vue?vue&type=script&lang=js&"
import style0 from "./leaving-message.vue?vue&type=style&index=0&id=32f269a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f269a9",
  null
  
)

export default component.exports